var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7 21.91V28.612H17.4144L17.4144 28.6099C17.4158 28.288 17.4179 27.8267 17.4202 27.2695C17.4247 26.1551 17.4301 24.6564 17.4337 23.1199C17.4398 20.5744 17.4409 17.9031 17.424 16.718H20.7V17.8926L20.2377 18.586H21.172H21.2H21.7V18.1962C21.96 17.8105 22.2957 17.3942 22.7764 17.0609C23.3007 16.6973 24.0243 16.414 25.064 16.414C26.3625 16.414 27.4526 16.8356 28.2219 17.6699C28.9949 18.5082 29.5 19.8242 29.5 21.718V28.612H26.214V22.212C26.214 21.3005 26.0533 20.455 25.6231 19.8239C25.1713 19.1609 24.4652 18.798 23.542 18.798C22.0878 18.798 21.2364 19.7878 20.8784 20.6788C20.7273 21.0517 20.7 21.5205 20.7 21.91ZM10.5 12.228C10.5 11.7272 10.6878 11.304 11.0062 11.0038C11.3256 10.7028 11.8043 10.5 12.426 10.5C13.0474 10.5 13.5097 10.7018 13.8174 10.9994C14.1249 11.2969 14.3114 11.7222 14.324 12.2335C14.3226 12.7217 14.1405 13.1444 13.8257 13.4466C13.5102 13.7495 13.0328 13.958 12.398 13.958H12.37C11.1962 13.958 10.5 13.1801 10.5 12.228ZM14.042 16.718V28.612H10.754V16.718H14.042Z",
    fill: "#F0F0F0",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 37.5C29.665 37.5 37.5 29.665 37.5 20C37.5 10.335 29.665 2.5 20 2.5C10.335 2.5 2.5 10.335 2.5 20C2.5 29.665 10.335 37.5 20 37.5ZM20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.291bfa8ce54aa77671a3b9dc1314078c.svg";
export { ForwardRef as ReactComponent };